export const ActionTypes = {
  SET_USER_DATA: "SET_USER_DATA",
  LOGOUT: "LOGOUT",
};
